"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwingValidator = void 0;
const DefaultErrorFactory_1 = require("../errors/DefaultErrorFactory");
const ThrowingValidationResult_1 = require("../validation-result/ThrowingValidationResult");
const ValidationOptions_1 = require("../ValidationOptions");
const NumberValidator_1 = require("../validators/NumberValidator");
const ObjectValidator_1 = require("../validators/ObjectValidator");
const StringValidator_1 = require("../validators/StringValidator");
const TimestampValidator_1 = require("../validators/TimestampValidator");
const throwingObjectValidatorOptions = new ValidationOptions_1.ValidationOptions(DefaultErrorFactory_1.defaultErrorFactory, (0, ThrowingValidationResult_1.throwingValidationResult)());
const throwingNumberValidatorOptions = new ValidationOptions_1.ValidationOptions(DefaultErrorFactory_1.defaultErrorFactory, (0, ThrowingValidationResult_1.throwingValidationResult)());
const throwingStringValidatorOptions = new ValidationOptions_1.ValidationOptions(DefaultErrorFactory_1.defaultErrorFactory, (0, ThrowingValidationResult_1.throwingValidationResult)());
const throwingTimestampValidatorOptions = new ValidationOptions_1.ValidationOptions(DefaultErrorFactory_1.defaultErrorFactory, (0, ThrowingValidationResult_1.throwingValidationResult)());
/**
 * A collection of default throwing validators that will throw an error automatically on validation failure.
 */
exports.throwingValidator = {
    objects: new ObjectValidator_1.ObjectValidator(throwingObjectValidatorOptions),
    strings: new StringValidator_1.StringValidator(throwingStringValidatorOptions),
    numbers: new NumberValidator_1.NumberValidator(throwingNumberValidatorOptions),
    timestamps: new TimestampValidator_1.TimestampValidator(throwingTimestampValidatorOptions)
};
